import RestService from "../../../../helpers/RestService"
import { ajaxUrls } from "../../../../settings/routes"

export const _imageSave = params => {
  const {editorType, questionId, file} = params
  let data = new FormData()
  data.append('Qupload[imageFile]', file)

  return RestService.customFetch(ajaxUrls.mcq1UploadImg, RestService.customFetchHeaders, data).then(middleThen => {
    return middleThen.json();
  }).then(({errcode, message, ...response}) => {
    if (errcode !== 200) {
        throw new Error('error')
    }
    return response
  })
}

export const deleteImgs = imgs => {
  let data = new FormData()
  data.append('imgs', JSON.stringify(imgs))

  return RestService.customFetch(ajaxUrls.mcq1UploadImgDelete, RestService.customFetchHeaders, data).then(middleThen => {
    return middleThen.json();
  }).then(({errcode, message, ...response}) => {
    if (errcode !== 200) {
        throw new Error('error')
    }
    return response
  })
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/EditorMedia/actions.js